<template>
    <div class="behaviorScore">
        <div class="top-box">
            <div class="left">
                <img src="../../assets/img/behavior_avtor.png">
                <div class="avtor-title">
                    <p class="top">hi，{{$route.query.driverName ? $route.query.driverName : '--' }}</p>
                    <p class="bottom">您当前行为分为：{{data.behaviorScore}}</p>
                </div>
            </div>
            <div class="right">
                <div id="myChart" class="myChart" @click="goScoreDetail"></div>
                <p class="desc">{{data.vipLevelName}}</p>
            </div>
        </div>
        <div class="card-box" v-if="data.behaviorEquityList && data.behaviorEquityList.length">
            <p>当前特权</p>
            <div class="card-contant-box">
                <div class="card-item" v-for="(item, index) in data.behaviorEquityList" :key="index">
                    <img :src="item.equityUrl">
                    <span>{{item.equityName}}</span>
                </div>
            </div>
        </div>
        <div class="content-box behaviorContet" :style="{'margin-top':data.behaviorEquityList && data.behaviorEquityList.length ? '1rem' : '-1.75rem' }">
            <p class="content-title">1.行为分是什么</p>
            <p class="content-text bottomText">
                行为分是万顺代驾平台用以考察司机在代驾服务中满足车主出行需求程度的综合评价体系。为真实、客观反映司机在代驾过程中的服务质量水平和车主对司机的满意度，依据平台《万顺代驾司机服务流程规范》、《万顺代驾司机管理手册》等相关文件基础上制定“万顺代驾行为分专项规则”。平台可通过行为分对司机在提供代驾服务过程中的行为是否符合服务标准进行验证和评估，将有针对性对司机进行管理培训，引导司机安全驾驶，提升车主服务质量。司机应认真严格遵守本规则，提高服务质量和行为分数，依据其各自行为分数享受对应的平台权益，司机行为分数越高，享受平台权益越多。
            </p>
            <p class="content-title">2.行为分等级</p>
            <p class="content-text">
                行为分为{{data.behaviorLevelList.length}}个档位，初始值{{data.initialValue}}分，最高分{{data.highestValue}}，最低分0分
            </p>
            <div class="table-box bottomText">
                <div class="table-head">
                    <p>分值条件</p>
                    <p class="two">档位名称</p>
                </div>
                <div class="table-content" v-for="(item, index) in data.behaviorLevelList" :key="index">
                    <p>{{item.startScore}} - {{ item.endScore}}</p>
                    <p>{{item.vipLevelName}}</p>
                </div>
            </div>
            <p class="content-title">3.行为分扣分准则</p>
            <p class="content-text">
                <span></span>司机取消订单扣减行为分；
            </p>
            <p class="content-text">
                <span></span>司机迟到扣减行为分；
            </p>
            <p class="content-text">
                <span></span>危险驾驶/非代驾司机本人接单/未按照服务规范进行服务/线下交易/虚假交易/中途拒驾/骚扰乘客/寻衅滋事/保险欺诈/因司机原因造成出险/扰乱平台秩序这些情况会扣减行为分；
            </p>
            <p class="content-text">
                <span></span>订单风控扣减行为分；
            </p>
        </div>

    </div>
</template>
<script>
import mobileType from "@/utils/mobileType";
import utils from "@/utils/util";
import { getBehaviorScoreInfo } from "@/apis/behaviorScore/index";
const btnIcon = require("../../assets/img/btn-icon.png");
export default {
    name: "behaviorScore",
    data() {
        return {
            dataList: [],
            finished: false,
            currentPage: 1,
            loading: false,
            params: {
                scale: "2.0",
                areaCode: "110105",
                sysVersion: "14.7",
                token:
                    "MTAxNzAwNjgxOjcwMDoyMDIzMDQyNzE2MDkxODY3MzpGNjQzM0EyRi0wNEIyLTRBRTEtOUE2QS1GMDI0MDEyNkZGMzY=",
                appChannel: "AppStore",
                platform: "2",
                softVersion: "1.2.51",
                display: "1334*750",
                role: "2",
                uuidString: "7021747C-162F-46D9-8761-99AA3621013A",
                channel: "1020000000",
                cityCode: "110100",
                idfv: "912FD003-76D6-4DAC-B98C-4B6FFF5A00C6"
            },
            timer: null,
            finishedText: "暂无数据",
            searchOptions: {},
            data: {
                behaviorScore: null,
                vipLevelName: "",
                behaviorLevelList: [],
                behaviorEquityList: [],
                standardScore: null
            },
            leverMax: null,
            columnar: null
        };
    },
    created() {
        window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
        this.getUserInfoFromApp();
        // this.getBehaviorScoreInfo()
    },
    computed: {},
    methods: {
        myChart() {
            this.columnar = this.$echarts.init(
                document.getElementById("myChart")
            );
            this.setChartOption(this.data.highestValue, this.data.behaviorScore);
        },
        setChartOption(max, value) {
            this.columnar.setOption({
                series: [
                    {
                        type: "gauge",
                        min: 0,
                        max,
                        splitNumber: 10,
                        startAngle: 180,
                        endAngle: 0,
                        radius: "78%",
                        itemStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 1,
                                x2: 1,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "rgba(255, 0, 0, 1)" // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.5,
                                        color: "rgba(255, 223, 0, 1)"
                                    },
                                    {
                                        offset: 1,
                                        color: "rgba(0, 213, 133, 1)" // 100% 处的颜色
                                    }
                                ],
                                global: false // 缺省为 false
                            }
                        },
                        progress: {
                            show: true,
                            roundCap: true,
                            width: 10
                        },
                        pointer: {
                            show: false
                        },
                        axisLine: {
                            roundCap: true,
                            lineStyle: {
                                width: 10
                            }
                        },
                        axisTick: {
                            distance: -14,
                            length: 2,
                            splitNumber: 5,
                            lineStyle: {
                                width: 1,
                                color: "#999"
                            }
                        },
                        splitLine: {
                            distance: -17,
                            length: 5,
                            lineStyle: {
                                width: 2,
                                color: "#999"
                            }
                        },
                        axisLabel: {
                            distance: -9,
                            color: "#999",
                            fontSize: 7
                        },
                        anchor: {
                            show: false
                        },
                        title: {
                            show: false
                        },
                        center:['60%','66%'],  //边距
                        detail: {
                            backgroundColor: "#47526F",
                            valueAnimation: true,
                            width: "40",
                            height: 12,
                            lineHeight: 12,
                            borderRadius: 15,
                            borderColor: "#8E8385",
                            borderWidth: 1,
                            offsetCenter: [0, "-12%"],
                            fontSize: 12,
                            fontWeight: "bolder",
                            formatter: [`{a|${value}}{b|}`].join("\n"),
                            color: "#fff",
                            rich: {
                                a: {
                                    color: "#fff",
                                    padding: [0, 2, 0, 0],
                                    fontSize: 16
                                },
                                b: {
                                    backgroundColor: {
                                        image: btnIcon
                                    },
                                    width: 7,
                                    height: 8
                                }
                            }
                        },
                        data: [
                            {
                                value
                            }
                        ]
                    }
                ]
            });
        },
        goScoreDetail() {
            wsdata.track('DJ_ActionDetailPageView', {
                page_path: window.location.origin + '/home/behaviorScoreDetail'
            })
            this.$router.push({
                path: "/home/behaviorScoreDetail"
            });
        },
        getUserInfoFromApp() {
            let params = {
                methodName: "getDataFromNative", //定义与原生的方法名(固定)
                type: 1 //业务类型(固定)
            };
            if (mobileType.isIOS()) {
                window.webkit.messageHandlers.getDataFromVue.postMessage(
                    params
                );
            } else if (mobileType.isAndroid()) {
                window.Android.getDataFromVue(JSON.stringify(params));
            }
        },
        getDataFromNative(params) {
            if (mobileType.isIOS()) {
                this.params = params;
            } else if (mobileType.isAndroid()) {
                this.params = JSON.parse(params);
            }
            this.getBehaviorScoreInfo()
        },
        async getBehaviorScoreInfo() {
            let params = { ...this.params };
            params.data = JSON.stringify({});
            try {
                const res = await getBehaviorScoreInfo(params);
                if (res.code == 1) {
                    this.data = JSON.parse(res.data);
                    this.data.behaviorLevelList = this.data.behaviorLevelList.reverse();
                    this.myChart();
                } else {
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.behaviorScore {
    width: 375px;
    background: #f7f7f7;
    padding-bottom: 16px;
    .top-box {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding: 18px 12px 50px 12px;
        background: linear-gradient(118deg, #485370 0%, #252b3b 100%);
        .left {
            display: flex;
            margin-top: 32px;
            margin-bottom: 25px;
            align-items: center;
            img {
                width: 45px;
                height: 45px;
            }
            .avtor-title {
                width: 140px;
                margin-left: 8px;
                color: #ffffff;
                .top {
                    height: 16px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    line-height: 16px;
                    width: 140px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .bottom {
                    height: 12px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: #ffffff;
                    line-height: 12px;
                    margin-top: 8px;
                }
            }
        }
        .right {
            position: relative;
            padding-bottom: 8px;
            .myChart {
                width: 200px;
                height: 150px;
                position: absolute;
                top: -15px;
                right: 0px;
            }
            img {
                width: 136px;
                height: 88px;
            }
            .button-btn {
                background: url("../../assets/img/btn-bg.png") no-repeat
                    no-repeat;
                background-size: 100% 100%;
                width: 65px;
                height: 24px;
                font-size: 19px;
                font-weight: 600;
                color: #ffffff;
                line-height: 24px;
                text-align: center;
                img {
                    width: 7px;
                    height: 8px;
                }
            }
            .desc {
                position: absolute;
                width: 150px;
                text-align: center;
                right: 0;
                top: 86px;
                height: 16px;
                font-size: 14px;
                font-weight: 600;
                color: #ffcf3c;
                line-height: 16px;
                margin-top: 6px;
            }
        }
    }
    .card-box {
        position: relative;
        margin: 0 12px;
        margin-top: -28px;
        background: url("../../assets/img/behavior_bg.png") no-repeat no-repeat;
        background-size: 100% 100%;
        // height: 134px;
        width: auto;
        padding: 16px 12px 20px 12px;
        p {
            height: 20px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 20px;
        }
        .card-contant-box {
            display: flex;
            margin-top: 16px;
            img {
                width: 44px;
                height: 44px;
            }
            .card-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-right: 12px;
                span {
                    display: block;
                    margin-top: 4px;
                    height: 14px;
                    font-size: 14px;
                    color: #333333;
                    line-height: 14px;
                }
            }
        }
    }
    .content-box {
        margin-bottom: 0;
    }
    .behaviorContet {
        padding: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #333333;
        line-height: 23px;
        // margin-top: -28px;
        position: relative;
        .content-title {
            height: 20px;
            font-size: 16px;
            font-weight: 600;
            line-height: 20px;
            margin-bottom: 4px;
            margin-top: 8px;
        }
        .bottomText {
            margin-bottom: 16px;
            line-height: 23px;
        }
        .content-text {
            color: #555;
            line-height: 23px;
            display: flex;
            span {
                display: block;
                width: 5px;
                height: 5px;
                background: #000;
                border-radius: 5px;
                margin-right: 8px;
                margin-top: 9px;
                margin-left: 3px;
                flex-shrink: 0;
            }
        }
        .table-box {
            text-align: center;
            border-radius: 4px 4px 0 0;
            overflow: hidden;
            margin-top: 4px;
            color: #555;
            .table-head {
                display: flex;
                color: #fff;
                font-size: 14px;
                font-weight: 500;
                color: #ffffff;
                p {
                    width: 163px;
                    height: 32px;
                    line-height: 32px;
                    font-weight: 600;
                    background: #ff8e6a;
                    flex: 1;
                    &.two {
                        height: 32px;
                        background: #ffa75d;
                    }
                }
            }
            .table-content {
                display: flex;
                color: #555;
                p {
                    width: 163px;
                    flex: 1;
                    height: 32px;
                    line-height: 32px;
                    border-right: 1px solid #dedede;
                    border-bottom: 1px solid #dedede;
                    color: #333;
                    font-size: 14px;
                    color: #555;
                    &:first-child {
                        border-left: 1px solid #dedede;
                    }
                }
            }
        }
    }
}
</style>
